import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@sica/ui';
import { AccessGate } from './components/gate/AccessGate';
import { App } from './App';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element not found');
}

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider defaultMode="system">
      <BrowserRouter>
        <AccessGate>
          <App />
        </AccessGate>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
